import React from "react";
import "./subscription-membership.css";
import Radio from "../Radio-Button/Radio";
import Checkbox from "../checkbox/Checkbox";
import ImageLogo from "../../../images/boldlogo.png";

function SubscriptionMembership({ changeStep }) {
  return (
    <>
      <div className="d-flex align-items-center pb-2 brand-head">
        <div>
          <div className="default_circle border-primary align-self-center">
            <img src={ImageLogo} alt="payulogo" width="20" />
          </div>
        </div>

        <div className="brand-name">
          <h2 className="font-weight-bold darkgrey ">Hungama Music</h2>
        </div>
      </div>

      <div className="d-flex">
        <div className="mt-2 mb-2 check">
          <Radio title="₹1499 / 1 year"></Radio>
        </div>
      </div>
      <div>
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            placeholder="Mobile Number"
          />
          <p className="my-2"> Please enter valid 10 digit Mobile Number </p>
        </div>
        <div className="form-group">
          <input type="text" className="form-control" placeholder="Email ID" />
          <p className="my-2">
            {" "}
            Please enter valid Email Id. You will receive the receipt there.{" "}
          </p>
        </div>

        <Checkbox title="Add to My Bills"></Checkbox>

        <div className="my-2">
          <button
            type="button"
            className="btn btn-primary btn-block mb-4"
            onClick={() => changeStep(4)}
          >
            Proceed
          </button>
          <button type="button" className="btn btn-primary-outline btn-block">
            Back
          </button>
        </div>
      </div>
    </>
  );
}

export default SubscriptionMembership;
